<template>
    <form style=" z-index: 1; position: relative;">
        <v-row align="start" class="mt-0 mt-md-3"  >
            <v-col  :key="componentKey" class="d-flex ml-0 my-0 py-0 caption"  cols="12" sm="3"  md="2" lg="2" xl="2"  >
                <v-select 
                    id="inputYear"
                    v-model="selectedYear"
                    @change="onChange()"
                    :items="years"
                    item-value='value'
                    item-text='label'
                    label="Year"
                    outlined
                    dense
                    eager
                >
                </v-select>
            </v-col>
        </v-row>
    </form>
</template>
<script>

import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
    data(){
        return {
            selectedYear:null,
            initialisation:1,
            componentKey:0,
        }
    },
    created(){
        this.allDataLoaders = Promise.all([
            this.fulfillYearsSelect(this.category_id).then( () => {
                this.initialisation = 1;
                if (this.upcomming) {
                    this.setTalksYear([2100,this.initialisation]);
                    this.selectedYear = 2100;
                    this.setCancelYear(2100);
                } 
                else if(this.cancelTalk){
                    this.selectedYear = this.cancelYear;
                    this.setTalksYear([this.cancelYear,this.initialisation]);
                    this.setCancelTalk(0);
                }
                else {
                    this.selectedYear = this.year;
                    this.setCancelYear(this.year);
                    this.setTalksYear([this.year,this.initialisation]);
                }    
            })
        ]);
        this.signalDataUpdate();    
        
    },
    computed: {
        ...mapGetters('header',{
           smAndDown:'smAndDown'
        }),
        ...mapGetters('talks',{
            year:'year',
            years:'years',
            cancelTalk:'cancelTalk',
            cancelYear:'cancelYear',
            category_id:'category_id',
            upcomming:'upcomming',
        }),
    },
    methods:{
        ...mapActions('talks',{
            setTalksYear:'setTalksYear',
            setCancelYear:'setCancelYear',
            setCancelTalk:'setCancelTalk',
            fulfillYearsSelect:'fulfillYearsSelect',
        }),
        onChange(){
            this.initialisation = 0;
            this.setCancelTalk(0);
            this.setCancelYear(this.selectedYear);
            this.setTalksYear([this.selectedYear,this.initialisation]);
        },
        async signalDataUpdate() {
            this.years;
            // Make sure all the needed data has been retrieved.
            await this.allDataLoaders;
            this.componentKey=this.componentKey+'1';
        },
    },
}
</script>
<style scoped>
 .v-input {
    min-height: 12px;
}

</style>
